import { useSearchFieldContext } from '../../context/SearchFieldContext';
import { FieldSearchOption } from '../../../../types';

export const useIsEventOption = () => {
  const { option } = useSearchFieldContext();
  return option === FieldSearchOption.Event;
};
